(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  (() => {
    if (customElements.get('tnf-sticky-header')) return;

    const DESKTOP_QUERY = '(min-width: 990px)';

    class TnfStickyHeader extends HTMLElement {
      connectedCallback() {
        this.section = this.closest('.shopify-section') || this.parentElement;
        this.header = this.querySelector('.tnf-header');
        this.search = this.querySelector('.tnf-search');
        this.quick = this.querySelector('.tnf-quick');
        this.icons = this.querySelector('.tnf-icons');
        this.row = this.querySelector('.tnf-row');
        this.quickSlot = this.querySelector('.tnf-quick-slot');
        this.drawer = this.querySelector('header-drawer');
        this.mainDetails = this.drawer ? this.drawer.querySelector('details') : null;
        this.panel = this.drawer ? this.drawer.querySelector('.menu-drawer') : null;
        this.mq = window.matchMedia(DESKTOP_QUERY);
        if (!this.header) return;

        this.state = { searchOff: false, hidden: -1, expanded: false, travel: 0, lastY: window.scrollY };
        this.revealEnabled = this.hasAttribute('data-reveal');
        this.distance = 0;
        this.full = 0;

        /* Direct bijwerken bij elk scroll-event (browsers sturen er hooguit één per
           beeld). Zo loopt de header nooit een beeld achter, ook niet als een
           browser zijn beeldverversing afknijpt (bijv. energiebesparing). */
        this.onScroll = () => {
          if (this.scrollLocked) return;
          if (this.desktop && this.revealEnabled) this.updateReveal();
          this.update();
        };
        this.onMediaChange = () => {
          this.unlockScroll();
          this.closeDrawer();
          this.requestMeasure();
          if (this.swipeList) this.updateSwipe();
        };
        this.resizeObserver = new ResizeObserver(() => {
          this.requestMeasure();
          if (this.swipeList) this.updateSwipe();
        });
        this.onMenuEscape = (event) => {
          if (event.key !== 'Escape' || !this.isDrawerOpen()) return;
          event.preventDefault();
          event.stopPropagation();
          this.closeDrawer();
          this.mainDetails.querySelector('summary')?.focus();
        };
        this.onDocumentClick = (event) => {
          if (!this.mq.matches || !this.isDrawerOpen() || !this.drawer) return;
          if (this.drawer.contains(event.target)) return;
          this.closeDrawer();
          const field = event.target.closest && event.target.closest('input, textarea, select');
          if (field) field.focus();
        };

        // Op mobiel heeft de header zelf geen vak; daarom ook de blokken zelf volgen.
        [this.header, this.row, this.search, this.quickSlot].forEach((el) => el && this.resizeObserver.observe(el));

        if (this.mainDetails) {
          this.drawerObserver = new MutationObserver(() => this.onDrawerChange());
          this.drawerObserver.observe(this.mainDetails, {
            attributes: true,
            attributeFilter: ['open', 'class'],
            subtree: true,
          });
        }

        // Terug-knop: Safari kan de pagina "bevroren" terugzetten. Staat het menu
        // dan niet (meer) open, dan de vergrendeling zeker opheffen.
        this.onPageShow = () => {
          if (this.scrollLocked && !this.isDrawerOpen()) this.unlockScroll();
        };
        window.addEventListener('pageshow', this.onPageShow);
        window.addEventListener('scroll', this.onScroll, { passive: true });
        this.mq.addEventListener('change', this.onMediaChange);
        document.addEventListener('click', this.onDocumentClick);
        document.addEventListener('keydown', this.onMenuEscape, true);
        // De vaste balk "Gratis verzending" boven de header meldt zijn hoogte.
        this.onTopbar = () => this.requestMeasure();
        document.addEventListener('tnf:topbar', this.onTopbar);

        this.measure();
        this.setupSwipe();
      }

      disconnectedCallback() {
        this.unlockScroll();
        window.removeEventListener('pageshow', this.onPageShow);
        window.removeEventListener('scroll', this.onScroll);
        if (this.mq) this.mq.removeEventListener('change', this.onMediaChange);
        document.removeEventListener('click', this.onDocumentClick);
        document.removeEventListener('keydown', this.onMenuEscape, true);
        document.removeEventListener('tnf:topbar', this.onTopbar);
        if (this.resizeObserver) this.resizeObserver.disconnect();
        if (this.drawerObserver) this.drawerObserver.disconnect();
        cancelAnimationFrame(this.measureFrame);
        cancelAnimationFrame(this.drawerFrame);
        cancelAnimationFrame(this.slideFrame);
        cancelAnimationFrame(this.swipeFrame);
        clearTimeout(this.hintTimer);
        clearTimeout(this.slideTimer);
        if (this.section) this.section.classList.remove('tnf-sliding');
        if (this.swipeList) this.swipeList.removeEventListener('scroll', this.onSwipeScroll);
        if (this.quick && this.onMoreClick) this.quick.removeEventListener('click', this.onMoreClick);
        if (this.section) this.section.style.removeProperty('--tnf-sticky-top');
      }

      requestMeasure() {
        cancelAnimationFrame(this.measureFrame);
        this.measureFrame = requestAnimationFrame(() => this.measure());
      }

      /* Alleen bij laden, resize of wisselen van breakpoint. Meet met offsetTop/
         offsetHeight: die worden niet beïnvloed door transforms, dus meten en
         animeren kunnen elkaar niet in een lus brengen. */
      measure() {
        this.desktop = this.mq.matches;
        // Hoogte van een vaste balk boven de header (0 als die er niet is).
        this.topbar = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--tnf-topbar-h')) || 0;
        this.full = this.header.offsetHeight;

        /* Desktop: afstand die de pagina de header omhoog mag duwen (negatieve
           sticky-top), tot alleen het snelmenu over is. */
        const quickTop = this.quick ? this.quick.offsetTop : 0;
        const searchTop = this.search ? this.search.offsetTop : 0;

        if (this.desktop) {
          const quickCenter = this.quick ? quickTop + this.quick.offsetHeight / 2 : this.full / 2;
          const searchCenter = this.search ? searchTop + this.search.offsetHeight / 2 : this.full / 2;
          const iconsHalf = (this.icons ? this.icons.offsetHeight : 44) / 2;
          this.distance = quickTop;
          this.iconsFrom = searchCenter - iconsHalf;
          this.iconsTo = quickCenter - iconsHalf;
          this.searchGone = this.distance;
        } else {
          /* Mobiel: alleen de bovenste rij is sticky (pure CSS); zoekbalk en
             snelmenu zijn gewone pagina-inhoud. Niets te meten voor het scrollen. */
          this.distance = 0;
          this.style.setProperty('--tnf-hidden', '0px');
          this.style.removeProperty('--tnf-actions-y');
        }
        if (this.desktop) {
          // Natuurlijke plek van de header in de pagina (onder bijv. de aankondigingsbalk).
          const sec = this.section;
          const prevPos = sec.style.position;
          sec.style.position = 'static';
          this.docTop = sec.getBoundingClientRect().top + window.scrollY;
          sec.style.position = prevPos;
        } else {
          this.state.expanded = false;
        }
        this.section.style.setProperty('--tnf-sticky-top', `${this.state.expanded ? 0 : -this.distance}px`);

        this.state.hidden = -1;
        this.state.lastY = window.scrollY;
        this.state.travel = 0;
        this.update();
      }

      /* Desktop: lager op de pagina ~10px omhoog scrollen schuift de volledige
         header (met zoekbalk) vloeiend terug in beeld; ~10px omlaag schuift hem
         weer terug tot alleen het snelmenu. Bovenaan werkt alles als voorheen:
         de pagina duwt de header omhoog. Het scrollen zelf blijft pure CSS
         (sticky); alleen bij een wissel schuift de header kort mee. */
      updateReveal() {
        const s = this.state;
        const y = window.scrollY;
        const delta = y - s.lastY;
        s.lastY = y;
        if (!delta || this.isDrawerOpen()) return;

        const dir = delta > 0 ? 1 : -1;
        if (dir !== s.dir) { s.dir = dir; s.travel = 0; }
        s.travel += Math.abs(delta);

        const pastHeader = y - this.docTop + this.topbar > this.distance;   // header is (deels) ingeklapt
        if (!s.expanded && dir < 0 && pastHeader && s.travel >= 10) {
          this.setExpanded(true);
        } else if (s.expanded && dir > 0 && s.travel >= 10) {
          this.setExpanded(false);
        } else if (s.expanded && y <= this.docTop - this.topbar) {
          // Helemaal bovenaan zijn beide standen gelijk: ongemerkt terug naar normaal.
          this.setExpanded(false, true);
        }
      }

      setExpanded(expanded, instant = false) {
        if (this.state.expanded === expanded) return;
        this.state.expanded = expanded;
        const sec = this.section;
        clearTimeout(this.slideTimer);
        cancelAnimationFrame(this.slideFrame);
        sec.classList.toggle('tnf-sliding', !instant);
        sec.style.setProperty('--tnf-sticky-top', `${expanded ? 0 : -this.distance}px`);
        if (instant) return;
        // Tijdens het schuiven logo en iconen elk beeld mee laten bewegen.
        const start = performance.now();
        const step = () => {
          this.update();
          if (performance.now() - start < 340) this.slideFrame = requestAnimationFrame(step);
        };
        this.slideFrame = requestAnimationFrame(step);
        this.slideTimer = setTimeout(() => sec.classList.remove('tnf-sliding'), 360);
      }

      update() {
        if (!this.desktop) {
          this.updateMobile();
          return;
        }
        /* Desktop: leest alleen hoe ver de browser de header al omhoog heeft geduwd. */
        const rect = this.section.getBoundingClientRect();
        const hidden = Math.min(this.distance, Math.max(0, (this.topbar || 0) - rect.top));

        if (Math.abs(hidden - this.state.hidden) > 0.1) {
          this.state.hidden = hidden;
          if (this.desktop) {
            const progress = this.distance > 0 ? hidden / this.distance : 0;
            this.style.setProperty('--tnf-hidden', `${hidden}px`);
            this.style.setProperty('--tnf-actions-y', `${this.iconsFrom + (this.iconsTo - this.iconsFrom) * progress}px`);
          }
        }
        this.setSearchEnabled(!(this.searchGone > 0 && hidden >= this.searchGone - 1));
        if (this.isDrawerOpen()) this.syncDrawer();

        this.setHeaderHeight(this.full - hidden + (this.topbar || 0));
      }

      /* --header-height (gebruikt door o.a. zoekresultaten en accountvenster) alleen
         bijwerken als hij echt verandert: schrijven naar de hele pagina bij elke
         scrollbeweging kost onnodig rekenwerk. */
      setHeaderHeight(px) {
        const value = Math.round(px);
        if (value === this.lastHeaderHeight) return;
        this.lastHeaderHeight = value;
        document.documentElement.style.setProperty('--header-height', `${value}px`);
      }

      /* Mobiel: alleen bijhouden of de zoekbalk zichtbaar is en waar de header
         eindigt (voor het uitklapmenu). Het scrollen zelf doet de browser. */
      updateMobile() {
        const rowBottom = this.row ? this.row.getBoundingClientRect().bottom : 0;
        const searchBottom = this.search ? this.search.getBoundingClientRect().bottom : 0;
        const slotBottom = this.quickSlot ? this.quickSlot.getBoundingClientRect().bottom : 0;

        // Zoekbalk volledig onder de rij? Dan niet klikbaar/focusbaar.
        this.setSearchEnabled(!this.search || searchBottom > rowBottom + 1);
        this.setHeaderHeight(Math.max(rowBottom, slotBottom));
        if (this.isDrawerOpen()) this.setDrawerTop();
      }

      /* Mobiel: pagina niet laten scrollen zolang het uitklapmenu openstaat.
         De body wordt tijdelijk vastgepind op de huidige scrollpositie; dan is er
         letterlijk niets meer om te scrollen, ook niet op de iPhone. Bij sluiten
         staat de pagina exact weer op dezelfde plek.
         Let op: een andere stijlregel op de site forceert
         body { position: initial !important }. Een !important-regel direct op het
         element wint daarvan, daarom setProperty(..., 'important'). */
      lockScroll() {
        if (this.scrollLocked) return;
        this.lockedY = window.scrollY;
        const b = document.body.style;
        b.setProperty('position', 'fixed', 'important');
        b.setProperty('top', `${-this.lockedY}px`, 'important');
        b.setProperty('left', '0', 'important');
        b.setProperty('right', '0', 'important');
        b.setProperty('width', '100%', 'important');
        this.scrollLocked = true;
      }

      unlockScroll() {
        if (!this.scrollLocked) return;
        const b = document.body.style;
        ['position', 'top', 'left', 'right', 'width'].forEach((prop) => b.removeProperty(prop));
        const html = document.documentElement;
        const prev = html.style.scrollBehavior;
        html.style.scrollBehavior = 'auto';          // direct terug, geen animatie
        window.scrollTo(0, this.lockedY || 0);
        html.style.scrollBehavior = prev;
        this.scrollLocked = false;
        this.update();
      }

      /* Exacte (niet afgeronde) onderkant van de zichtbare header, voor het
         mobiele uitklapmenu en de donkere overlay. */
      setDrawerTop() {
        let bottom;
        if (this.mq.matches) {
          bottom = Math.max(0, this.getBoundingClientRect().bottom);
        } else {
          const rowBottom = this.row ? this.row.getBoundingClientRect().bottom : 0;
          const slotBottom = this.quickSlot ? this.quickSlot.getBoundingClientRect().bottom : 0;
          bottom = Math.max(0, rowBottom, slotBottom);
        }
        this.style.setProperty('--tnf-drawer-top', `${bottom}px`);
        document.documentElement.style.setProperty('--header-bottom-position', `${Math.round(bottom)}px`);
      }

      /* ---------- Mobiel snelmenu als swipe-strook ---------- */
      setupSwipe() {
        this.swipeList = this.quick ? this.quick.querySelector('.tnf-quick__list') : null;
        if (!this.swipeList) return;

        this.onSwipeScroll = () => {
          if (this.swipeFrame) return;
          this.swipeFrame = requestAnimationFrame(() => {
            this.swipeFrame = 0;
            this.updateSwipe();
          });
        };
        this.swipeList.addEventListener('scroll', this.onSwipeScroll, { passive: true });
        // Tikken op een pijltje schuift de strook ~70% van de breedte door.
        this.onMoreClick = (event) => {
          const btn = event.target.closest('.tnf-quick__more');
          if (!btn || !this.swipeList) return;
          const dir = Number(btn.dataset.dir) || 1;
          this.swipeList.scrollBy({ left: dir * this.swipeList.clientWidth * 0.7, behavior: 'smooth' });
        };
        this.quick.addEventListener('click', this.onMoreClick);
        this.resizeObserver.observe(this.swipeList);

        // Actieve groep direct in beeld schuiven.
        const current = this.swipeList.querySelector('.tnf-quick__link--current');
        if (current && !this.mq.matches) {
          const item = current.closest('li');
          const x = item.offsetLeft - this.swipeList.offsetLeft - 24;
          this.swipeList.scrollLeft = x < 40 ? 0 : x;   // staat hij al (bijna) in beeld? dan niet verschuiven
        }
        this.updateSwipe();
        this.hintSwipe();
      }

      updateSwipe() {
        const list = this.swipeList;
        if (!list) return;
        const max = list.scrollWidth - list.clientWidth;
        const overflow = !this.mq.matches && max > 2;
        list.toggleAttribute('data-overflow', overflow);
        const left = overflow && list.scrollLeft > 8;
        const right = overflow && list.scrollLeft < max - 8;
        list.toggleAttribute('data-fade-left', left);
        list.toggleAttribute('data-fade-right', right);
        // Pijltjes (›) aan de kant waar nog meer staat
        this.quick.toggleAttribute('data-more-left', left);
        this.quick.toggleAttribute('data-more-right', right);
      }

      /* Eenmalig per bezoek een klein duwtje naar links: "hier kun je swipen". */
      hintSwipe() {
        const list = this.swipeList;
        if (!list || this.mq.matches || !list.hasAttribute('data-fade-right')) return;
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        try {
          if (sessionStorage.getItem('tnfSwipeHint')) return;
          sessionStorage.setItem('tnfSwipeHint', '1');
        } catch (e) {}
        const stop = () => list.classList.remove('is-hinting');
        clearTimeout(this.hintTimer);
        this.hintTimer = setTimeout(() => {
          list.classList.add('is-hinting');
          setTimeout(stop, 1200);
        }, 900);
        list.addEventListener('pointerdown', stop, { once: true });
      }

      /* Een verborgen zoekbalk is niet klikbaar en niet focusbaar. */
      setSearchEnabled(enabled) {
        if (!this.search || this.state.searchOff === !enabled) return;
        this.state.searchOff = !enabled;
        this.search.inert = !enabled;
      }

      isDrawerOpen() {
        return !!(this.mainDetails && this.mainDetails.hasAttribute('open'));
      }

      closeDrawer() {
        if (!this.isDrawerOpen() || !this.drawer || typeof this.drawer.closeMenuDrawer !== 'function') return;
        const summary = this.mainDetails.querySelector('summary');
        this.drawer.closeMenuDrawer(new Event('click'), summary);
        if (summary) summary.setAttribute('aria-expanded', 'false');
      }

      onDrawerChange() {
        if (!this.mq.matches) {
          if (this.isDrawerOpen()) {
            this.setDrawerTop();
            this.lockScroll();
          } else {
            this.unlockScroll();
          }
          return;
        }
        cancelAnimationFrame(this.drawerFrame);
        this.drawerFrame = requestAnimationFrame(() => this.syncDrawer());
      }

      /* Desktop: hoogte van de dropdown = inhoud van het actieve (sub)menu,
         begrensd door de ruimte tot onderaan het scherm. */
      syncDrawer() {
        if (!this.panel) return;
        if (!this.mq.matches || !this.isDrawerOpen()) {
          this.panel.style.removeProperty('--tnf-drawer-h');
          this.drawerHeight = 0;
          return;
        }
        const submenus = this.panel.querySelectorAll('details.menu-opening > .menu-drawer__submenu');
        const active = submenus[submenus.length - 1];
        const content = active
          ? active.querySelector('.menu-drawer__inner-submenu') || active
          : this.panel.querySelector('.menu-drawer__inner-container') || this.panel;
        const room = window.innerHeight - this.getBoundingClientRect().bottom - 16;
        const height = Math.ceil(Math.max(160, Math.min(content.scrollHeight, room)));
        if (height !== this.drawerHeight) {
          this.drawerHeight = height;
          this.panel.style.setProperty('--tnf-drawer-h', `${height}px`);
        }
        if (active && this.panel.scrollTop) this.panel.scrollTop = 0;
      }
    }

    customElements.define('tnf-sticky-header', TnfStickyHeader);
  })();

  // Account-dialoog (Trade 16) direct onder de accountknop openen.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;
      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnf-featured-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Image widths used by the theme's product gallery (product-thumbnail snippet).
  // Hover previews use the same widths and sizes, so the browser downloads each photo only once.
  const TNF_GALLERY_WIDTHS = [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946];
  const TNF_CACHE_SIZE = 6;
  const TNF_CACHE_TTL = 120000;
  const TNF_IMAGE_WAIT = 2500;
  const TNF_REQUEST_TIMEOUT = 15000;
  const TNF_SPECULATION = !!(window.HTMLScriptElement?.supports && HTMLScriptElement.supports('speculationrules'));

  // Product photos: swipe through the large photo (touch and trackpad); the thumbnails below jump to a photo
  // and show which one is visible.
  if (!customElements.get('tnf-media-dots')) {
    customElements.define('tnf-media-dots', class extends HTMLElement {
      connectedCallback() {
        this.ready = () => this.setup();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.ready, { once: true });
        else this.setup();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.ready);
        this.resize?.disconnect();
        this.track?.removeEventListener('scroll', this.onScroll);
        cancelAnimationFrame(this.frame);
      }

      setup() {
        this.track = this.querySelector('.product__media-list');
        if (!this.track) return;
        // Slides the theme hides (variant photos with "hide other variants' media") are skipped.
        const all = Array.from(this.track.children).filter((el) => el.matches('.product__media-item'));
        const visible = all.filter((el) => el.getClientRects().length);
        this.slides = visible.length ? visible : all;
        this.strip = this.querySelector('.tnf-thumbs');
        this.thumbs = [];
        if (this.strip) {
          this.strip.querySelectorAll('.tnf-thumb').forEach((thumb) => {
            const slide = this.slides.find((el) => el.dataset.mediaId === thumb.dataset.tnfMediaId);
            thumb.hidden = !slide;
            if (!slide) return;
            this.thumbs.push({ thumb, slide });
            thumb.addEventListener('click', () => this.show(slide));
          });
          if (this.thumbs.length < 2) this.strip.hidden = true;
        }
        if (this.slides.length < 2) return;
        this.onScroll = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.update());
        };
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        this.resize = new ResizeObserver(() => this.update());
        this.resize.observe(this.track);
        this.update();
      }

      show(slide) {
        // scrollTo with an absolute position: a relative scrollBy stops at the next photo because of scroll-snap-stop.
        const dx = slide.getBoundingClientRect().left - this.track.getBoundingClientRect().left;
        this.track.scrollTo({ left: this.track.scrollLeft + dx, behavior: 'instant' });
        this.update();
      }

      update() {
        const left = this.track.getBoundingClientRect().left;
        let current = 0;
        let distance = Infinity;
        this.slides.forEach((slide, i) => {
          const delta = Math.abs(slide.getBoundingClientRect().left - left);
          if (delta < distance) {
            distance = delta;
            current = i;
          }
        });
        const active = this.slides[current];
        this.thumbs.forEach(({ thumb, slide }) => {
          if (slide === active) thumb.setAttribute('aria-current', 'true');
          else thumb.removeAttribute('aria-current');
        });
        if (this.current !== current) {
          this.slides.forEach((slide, i) => {
            if (i !== current) slide.querySelectorAll('video').forEach((video) => video.pause());
          });
          this.current = current;
          this.revealThumb(active);
        }
      }

      // Keeps the active thumbnail in view when there are more photos than fit in one row.
      // Scrolls only the thumbnail row, never the page.
      revealThumb(slide) {
        const entry = this.thumbs.find((t) => t.slide === slide);
        if (!entry || !this.strip || this.strip.scrollWidth <= this.strip.clientWidth) return;
        const strip = this.strip.getBoundingClientRect();
        const box = entry.thumb.getBoundingClientRect();
        if (box.left < strip.left) this.strip.scrollLeft -= strip.left - box.left;
        else if (box.right > strip.right) this.strip.scrollLeft += box.right - strip.right;
      }
    });
  }

  if (!customElements.get('tnf-featured-colors')) {
    customElements.define('tnf-featured-colors', class extends HTMLElement {
      connectedCallback() {
        this.readyHandler = () => this.initialize();
        if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', this.readyHandler, { once: true });
        else this.initialize();
      }

      disconnectedCallback() {
        document.removeEventListener('DOMContentLoaded', this.readyHandler);
        window.removeEventListener('load', this.themeEventsHandler);
        window.removeEventListener('pageshow', this.pageShowHandler);
        clearTimeout(this.navigationTimer);
        clearTimeout(this.pagePrefetchTimer);
        this.stockObserver?.disconnect();
        this.buyResize?.disconnect();
        window.removeEventListener('click', this.cartClickListener, true);
        window.removeEventListener('submit', this.cartSubmitListener, true);
        document.removeEventListener('cart:updated', this.monsterCartListener);
        this.cartCaptureConnected = false;
        this.cartUnsubscribe?.();
        this.cartErrorUnsubscribe?.();
        this.cartUnsubscribe = null;
        this.cartErrorUnsubscribe = null;
        clearTimeout(this.cartFeedbackTimer);
        this.clearCartFeedback();
        this.pendingAdd = null;
        this.selectionRequest = (this.selectionRequest || 0) + 1;
        this.selectionAbort?.abort();
        clearTimeout(this.prefetchTimer);
        this.prefetchRequest?.controller.abort();
        this.pendingSelectionLink = null;
        this.setSelectionBusy(false);
        this.restoreSelection();
      }

      initialize() {
        this.setupCartFeedback();
        if (this.initialized) return;
        this.panel = this.querySelector('[data-tnf-panel]');
        this.setupStockLimit();
        this.picker = this.panel?.querySelector('[data-tnf-picker-slot] [data-tnf-color-picker]');
        if (!this.picker) return;
        this.initialized = true;
        // "page": a colour click opens that colour's own product page (see goToColor).
        this.pageMode = this.dataset.tnfSwitch === 'page';
        this.pageShowHandler = (event) => {
          // Back button: the page comes from the browser cache with the clicked colour still previewed.
          if (!event.persisted || !this.pageMode) return;
          this.cancelNavigation();
        };
        window.addEventListener('pageshow', this.pageShowHandler);
        this.selectedProductId = this.panel.dataset.tnfPanel;
        // The first panel is not cached from the DOM: the theme already moved its lightbox to <body>.
        // Returning to this colour fetches clean server markup instead.
        this.panelCache = new Map();
        this.selectionRequest = 0;

        // Only leaving the whole swatch group restores the committed selection.
        // Gaps between swatches remain inside this group and do not reset the preview.
        const swatches = this.picker.querySelector('.tnf-color-rows');
        swatches?.addEventListener('pointerleave', (event) => {
          if (event.pointerType === 'touch') return;
          clearTimeout(this.prefetchTimer);
          queueMicrotask(() => {
            if (this.isConnected && !swatches.matches(':hover')) this.restoreSelection();
          });
        });
        this.picker.addEventListener('focusout', () => {
          queueMicrotask(() => {
            if (this.isConnected && !this.picker.contains(document.activeElement)) this.restoreSelection();
          });
        });
        this.addEventListener('pointerover', (event) => {
          if (event.pointerType === 'touch') return;
          const link = event.target.closest('a[data-tnf-switch]');
          if (link && this.picker.contains(link)) {
            this.preview(link);
            if (this.pageMode) this.prefetchPage(link, 150);
            else this.schedulePrefetch(link);
          }
        });
        this.addEventListener('pointerdown', (event) => {
          // A finger on a colour: start loading its page right away, before the tap completes.
          if (event.pointerType !== 'touch' || !this.pageMode) return;
          const link = event.target.closest('a[data-tnf-switch]');
          if (link && this.picker.contains(link)) this.prefetchPage(link, 0);
        });
        this.addEventListener('focusin', (event) => {
          const link = event.target.closest('a[data-tnf-switch]');
          if (link && this.picker.contains(link)) {
            this.preview(link);
            if (this.pageMode) this.prefetchPage(link, 150);
            else this.schedulePrefetch(link);
          }
        });
        // Modified clicks (new tab etc.) keep the native link behaviour.
        this.addEventListener('click', (event) => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          const link = event.target.closest('a[data-tnf-switch]');
          if (!link || !this.picker.contains(link)) return;
          if (this.pageMode) {
            this.goToColor(link, event);
            return;
          }
          event.preventDefault();
          this.selectProduct(link);
        });
      }

      /* ---------- Cart feedback ("Toegevoegd!") ---------- */

      setupCartFeedback() {
        if (!this.cartSubmitListener) {
          this.cartQuantities = new Map();
          this.cartSnapshotReady = false;
          this.cartSnapshotVersion = 0;
          this.armCartFeedback = (form) => {
            if (this.loadingSelection || !form || !this.contains(form) || !form.closest('product-form')) return;
            const button = form.querySelector('[type="submit"]');
            if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
            const variant = String(new FormData(form).get('id'));
            if (!variant || variant === 'null') return;
            if (this.pendingAdd?.button === button && Date.now() - this.pendingAdd.time < 500) return;
            this.clearCartFeedback();
            this.pendingAdd = {
              button,
              variant,
              time: Date.now(),
              baseline: this.cartSnapshotReady ? this.cartQuantities.get(variant) || 0 : null,
            };
          };
          this.cartClickListener = (event) => {
            if (event.button !== 0) return;
            const button = event.target.closest?.('button[type="submit"], input[type="submit"], button[name="add"]');
            if (button && this.contains(button)) {
              if (this.loadingSelection || !this.checkStockBeforeAdd()) {
                event.preventDefault();
                event.stopImmediatePropagation();
                return;
              }
              this.restoreSelection();
              this.armCartFeedback(button.form || button.closest('form'));
            }
          };
          this.cartSubmitListener = (event) => {
            if (this.contains(event.target) && (this.loadingSelection || !this.checkStockBeforeAdd())) {
              event.preventDefault();
              event.stopImmediatePropagation();
              return;
            }
            if (this.contains(event.target)) this.restoreSelection();
            this.armCartFeedback(event.target);
          };
          this.monsterCartListener = (event) => {
            const items = event.detail?.items;
            if (!Array.isArray(items)) return;
            this.clearPanelCache();
            const quantities = new Map();
            items.forEach((item) => {
              const id = String(item.variant_id ?? item.id);
              quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
            });
            this.cartQuantities = quantities;
            this.cartSnapshotReady = true;
            this.cartSnapshotVersion++;
            this.applyStockLimit();
            const pending = this.pendingAdd;
            if (
              pending &&
              pending.baseline !== null &&
              Date.now() - pending.time <= 30000 &&
              (quantities.get(pending.variant) || 0) > pending.baseline
            ) {
              this.showCartFeedback(pending);
            }
          };
          this.themeEventsHandler = () => {
            if (this.isConnected) this.connectThemeCartEvents();
          };
        }
        if (!this.cartCaptureConnected) {
          // Window capture runs before MonsterCart's document click interception.
          window.addEventListener('click', this.cartClickListener, true);
          window.addEventListener('submit', this.cartSubmitListener, true);
          document.addEventListener('cart:updated', this.monsterCartListener);
          this.cartCaptureConnected = true;
          this.refreshCartSnapshot();
        }
        // The theme's own events may load after this script; try again once the page has loaded.
        if (!this.connectThemeCartEvents() && document.readyState !== 'complete') {
          window.addEventListener('load', this.themeEventsHandler, { once: true });
        }
      }

      // Reads the cart once (start, or after a cart change by the theme's own form).
      refreshCartSnapshot() {
        const version = this.cartSnapshotVersion;
        const root = window.Shopify?.routes?.root || '/';
        return fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then((response) => (response.ok ? response.json() : null))
          .then((cart) => {
            // Never let an older read overwrite a newer MonsterCart update.
            if (!this.isConnected || this.cartSnapshotVersion !== version || !Array.isArray(cart?.items)) return;
            const quantities = new Map();
            cart.items.forEach((item) => {
              const id = String(item.variant_id ?? item.id);
              quantities.set(id, (quantities.get(id) || 0) + Number(item.quantity || 0));
            });
            this.cartQuantities = quantities;
            this.cartSnapshotReady = true;
            this.cartSnapshotVersion++;
            this.applyStockLimit();
          })
          .catch(() => {});
      }

      connectThemeCartEvents() {
        if (this.cartUnsubscribe) return true;
        if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return false;
        // Also supports the normal theme form when MonsterCart does not intercept it.
        this.cartUnsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          this.clearPanelCache();
          this.refreshCartSnapshot();
          const pending = this.pendingAdd;
          if (!pending || event.source !== 'product-form' || !event.cartData || event.cartData.status) return;
          if (String(event.productVariantId) !== pending.variant || Date.now() - pending.time > 30000) return;
          this.showCartFeedback(pending);
        });
        if (PUB_SUB_EVENTS.cartError) {
          this.cartErrorUnsubscribe = subscribe(PUB_SUB_EVENTS.cartError, (event) => {
            if (this.pendingAdd && String(event.productVariantId) === this.pendingAdd.variant) this.pendingAdd = null;
          });
        }
        return true;
      }

      showCartFeedback(pending) {
        this.pendingAdd = null;
        const button = pending.button;
        if (!button.isConnected || !this.contains(button)) return;
        const label = button.querySelector('span');
        if (!label) return;
        this.clearCartFeedback();
        const original = label.innerHTML;
        const fill = window.getComputedStyle(button).backgroundColor;
        if (fill && fill !== 'transparent' && fill !== 'rgba(0, 0, 0, 0)') button.style.setProperty('--tnf-added-border', fill);
        button.classList.add('tnf-cart-added');
        label.innerHTML =
          '<svg class="tnf-cart-check" aria-hidden="true" viewBox="0 0 24 24" width="20" height="20" style="vertical-align:middle;margin-right:8px" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12 4 4L19 6"/></svg>Toegevoegd!';
        this.cartFeedback = { button, label, original, success: label.innerHTML };
        let status = this.querySelector('[data-tnf-cart-status]');
        if (!status) {
          status = document.createElement('span');
          status.className = 'visually-hidden';
          status.setAttribute('data-tnf-cart-status', '');
          status.setAttribute('role', 'status');
          status.setAttribute('aria-live', 'polite');
          this.append(status);
        }
        status.textContent = 'Toegevoegd aan je winkelwagen!';
        this.cartFeedbackTimer = setTimeout(() => {
          this.clearCartFeedback();
          status.textContent = '';
        }, 2000);
      }

      clearCartFeedback() {
        clearTimeout(this.cartFeedbackTimer);
        const state = this.cartFeedback;
        // Do not overwrite a newer sold-out or variant-selection message.
        if (state && state.label.innerHTML === state.success) state.label.innerHTML = state.original;
        if (state?.button) {
          state.button.classList.remove('tnf-cart-added');
          state.button.style.removeProperty('--tnf-added-border');
        }
        this.cartFeedback = null;
      }

      /* ---------- Panel cache ---------- */

      cachePanel(id, html) {
        if (!this.panelCache) return;
        this.panelCache.delete(id);
        this.panelCache.set(id, { html, time: Date.now() });
        // Bounded cache: never more than a few product panels in memory.
        while (this.panelCache.size > TNF_CACHE_SIZE) this.panelCache.delete(this.panelCache.keys().next().value);
      }

      cachedPanel(id) {
        const cached = this.panelCache?.get(id);
        return cached && Date.now() - cached.time < TNF_CACHE_TTL ? cached.html : null;
      }

      clearPanelCache() {
        // Cached panels contain the cart quantity at fetch time; after a cart change they are stale.
        this.cartVersion = (this.cartVersion || 0) + 1;
        this.panelCache?.clear();
        if (this.prefetchRequest) {
          this.prefetchRequest.controller.abort();
          this.prefetchRequest = null;
        }
      }

      /* ---------- Selection state ---------- */

      // Shows the name of the given swatch in its row (Rustig) or the "Gekozen" line (Tabs); other rows show their count.
      setColorLabel(link) {
        if (!this.picker || !link) return;
        const text = link.dataset.tnfLabel || link.dataset.tnfTitle;
        const label = this.picker.querySelector('[data-tnf-color-label]');
        if (label) label.textContent = text;
        const row = link.closest('[data-tnf-row]');
        this.picker.querySelectorAll('[data-tnf-row]').forEach((r) => {
          const meta = r.querySelector('[data-tnf-row-meta]');
          if (meta) meta.textContent = r === row ? link.dataset.tnfTitle : r.dataset.tnfCountText;
          // "Kleur: 01" — only the row that holds the chosen colour shows its number.
          const selected = r.querySelector('[data-tnf-row-selected]');
          if (selected) {
            if (r === row) {
              const value = document.createElement('span');
              value.className = 'tnf-color-row__value';
              value.textContent = text;
              selected.replaceChildren(': ', value);
            } else {
              selected.replaceChildren();
            }
          }
        });
      }

      updateSelectedSwatch() {
        this.picker.querySelectorAll('a[data-tnf-product]').forEach((a) => {
          if (a.dataset.tnfProduct === this.selectedProductId) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
      }

      setSelectionBusy(busy) {
        this.loadingSelection = busy;
        if (busy) this.panel?.setAttribute('aria-busy', 'true');
        else this.panel?.removeAttribute('aria-busy');
        if (busy && !this.lockedControls && this.panel) {
          this.lockedControls = Array.from(
            this.panel.querySelectorAll('product-form, .shopify-payment-button, [name="add"], button[type="submit"]')
          ).map((node) => ({ node, inert: node.hasAttribute('inert'), disabled: node.disabled }));
          this.lockedControls.forEach(({ node }) => {
            node.setAttribute('inert', '');
            if ('disabled' in node) node.disabled = true;
          });
        } else if (!busy && this.lockedControls) {
          this.lockedControls.forEach(({ node, inert, disabled }) => {
            if (!inert) node.removeAttribute('inert');
            if (disabled !== undefined) node.disabled = disabled;
          });
          this.lockedControls = null;
        }
      }

      /* ---------- Hover / focus preview ---------- */

      restoreSelection() {
        // During a click request, keep that colour's preview until its form is ready.
        if ((this.loadingSelection || this.navigatingLink) && (this.pendingSelectionLink || this.navigatingLink)) {
          this.preview(this.pendingSelectionLink || this.navigatingLink);
          return;
        }
        this.cancelPendingPreview();
        this.previewProductId = null;
        this.previewImage?.remove();
        this.previewImage = null;
        this.panel?.querySelectorAll('[data-tnf-preview-hidden]').forEach((node) => node.removeAttribute('data-tnf-preview-hidden'));
        if (this.originalTitle !== undefined) {
          const title = this.panel?.querySelector('.product__title');
          if (title) title.textContent = this.originalTitle;
          this.originalTitle = undefined;
        }
        const selected = this.picker?.querySelector('a[aria-current="true"]');
        if (selected) this.setColorLabel(selected);
      }

      cancelPendingPreview() {
        const image = this.pendingPreview;
        if (!image) return;
        this.pendingPreview = null;
        image.onload = null;
        image.onerror = null;
        // Stops a download for a colour the pointer already left.
        image.removeAttribute('srcset');
        image.removeAttribute('src');
      }

      previewSources(link) {
        const base = link.dataset.tnfImage;
        if (!base) return null;
        const current = this.panel.querySelector('tnf-media-dots .product__media-list .product__media-item img');
        let widths = TNF_GALLERY_WIDTHS;
        const srcset = current?.getAttribute('srcset');
        if (srcset) {
          const parsed = srcset
            .split(',')
            .map((part) => parseInt(part.trim().split(/\s+/)[1], 10))
            .filter((width) => width > 0);
          if (parsed.length) widths = parsed;
        }
        const withWidth = (width) => base.replace(/([?&]width=)\d+/, '$1' + width);
        return {
          src: base,
          srcset: widths.map((width) => withWidth(width) + ' ' + width + 'w').join(', '),
          sizes: current?.getAttribute('sizes') || '100vw',
        };
      }

      preview(link) {
        const id = link.dataset.tnfProduct;
        if (this.navigatingLink && link !== this.navigatingLink) return;
        if (id === this.panel.dataset.tnfPanel && !this.loadingSelection) {
          this.restoreSelection();
          return;
        }
        if (this.previewProductId === id) return;
        this.previewProductId = id;
        const show = (image) => {
          if (!this.isConnected || this.previewProductId !== id) return;
          const title = this.panel.querySelector('.product__title');
          if (title) {
            if (this.originalTitle === undefined) this.originalTitle = title.textContent;
            title.textContent = link.dataset.tnfTitle;
          }
          this.setColorLabel(link);
          const media = this.panel.querySelector('tnf-media-dots .tnf-media-main') || this.panel.querySelector('tnf-media-dots');
          if (media && image) {
            if (this.previewImage !== image) this.previewImage?.remove();
            media.querySelector('media-gallery')?.setAttribute('data-tnf-preview-hidden', '');
            image.className = 'tnf-hover-image';
            image.alt = link.dataset.tnfTitle;
            // Same crop as on that colour's own page: its focal point, otherwise the section setting.
            image.style.objectPosition = link.dataset.tnfFocal || '';
            media.append(image);
            this.previewImage = image;
          }
        };
        const sources = this.previewSources(link);
        this.cancelPendingPreview();
        if (!sources) {
          show(null);
          return;
        }
        const image = new Image();
        this.pendingPreview = image;
        const done = () => {
          if (this.pendingPreview === image) this.pendingPreview = null;
          image.onload = null;
          image.onerror = null;
        };
        image.onload = () => {
          done();
          show(image);
        };
        image.onerror = () => {
          done();
          if (this.previewProductId === id) this.previewProductId = null;
        };
        image.sizes = sources.sizes;
        image.srcset = sources.srcset;
        image.src = sources.src;
        if (image.complete && image.naturalWidth) {
          done();
          show(image);
        }
      }

      /* ---------- Colour as its own page ---------- */

      // Starts downloading a colour's page, so the click opens it almost at once.
      // Chrome and Edge do this through the speculation rules in the section; other browsers get a prefetch link.
      prefetchPage(link, delay) {
        if (TNF_SPECULATION || link.dataset.tnfProduct === this.selectedProductId) return;
        clearTimeout(this.pagePrefetchTimer);
        this.pagePrefetchTimer = setTimeout(() => {
          this.prefetchedPages = this.prefetchedPages || new Set();
          if (this.prefetchedPages.has(link.href)) return;
          this.prefetchedPages.add(link.href);
          const hint = document.createElement('link');
          hint.rel = 'prefetch';
          hint.as = 'document';
          hint.href = link.href;
          document.head.append(hint);
        }, delay);
      }

      // The click follows the link as normal. Before that: remember where the picker is on screen,
      // so the new page opens at the same height, and show the new colour while it loads.
      goToColor(link, event) {
        if (link.dataset.tnfProduct === this.selectedProductId) {
          event.preventDefault();
          this.restoreSelection();
          return;
        }
        try {
          sessionStorage.setItem(
            'tnf-color-nav',
            JSON.stringify({
              path: new URL(link.href, window.location.href).pathname,
              top: Math.round(this.picker.getBoundingClientRect().top),
              time: Date.now(),
            })
          );
        } catch (error) {}
        this.navigatingLink = null;
        this.preview(link);
        this.navigatingLink = link;
        this.picker.querySelectorAll('a[data-tnf-product]').forEach((a) => {
          if (a === link) a.setAttribute('aria-current', 'true');
          else a.removeAttribute('aria-current');
        });
        this.setColorLabel(link);
        this.panel?.setAttribute('aria-busy', 'true');
        // If the page does not open (stopped, offline), show the current colour again.
        clearTimeout(this.navigationTimer);
        this.navigationTimer = setTimeout(() => this.cancelNavigation(), 10000);
      }

      cancelNavigation() {
        clearTimeout(this.navigationTimer);
        if (!this.navigatingLink) return;
        this.navigatingLink = null;
        this.panel?.removeAttribute('aria-busy');
        this.updateSelectedSwatch();
        this.restoreSelection();
      }

      /* ---------- Stock limit ---------- */

      setupStockLimit() {
        this.stockObserver?.disconnect();
        this.buyResize?.disconnect();
        const input = this.panel?.querySelector('.quantity__input');
        // Keeps the quantity box exactly as tall as the add-to-cart button next to it.
        const row = this.panel?.querySelector('.tnf-buy-row');
        const submit = row?.querySelector('[name="add"], button[type="submit"]');
        if (row && submit && window.ResizeObserver) {
          this.buyResize = new ResizeObserver(() => {
            const height = submit.getBoundingClientRect().height;
            if (height > 0) row.style.setProperty('--tnf-buy-h', height + 'px');
          });
          this.buyResize.observe(submit);
        }
        if (!input) return;
        this.qtyTouched = false;
        if (input.dataset.tnfStockBound !== 'true') {
          input.dataset.tnfStockBound = 'true';
          input.addEventListener('change', () => this.applyStockLimit({ touched: true }));
          // + at the maximum changes nothing (so no change event): still tell the customer why.
          input
            .closest('quantity-input')
            ?.querySelectorAll('.quantity__button')
            .forEach((button) => button.addEventListener('click', () => setTimeout(() => this.applyStockLimit({ touched: true }))));
        }
        // The theme rewrites min/max/value after cart changes; check the limit again when it does.
        this.stockObserver = new MutationObserver(() => {
          cancelAnimationFrame(this.stockFrame);
          this.stockFrame = requestAnimationFrame(() => this.applyStockLimit());
        });
        this.stockObserver.observe(input, { attributes: true, attributeFilter: ['max', 'value', 'data-cart-quantity'] });
        this.applyStockLimit();
      }

      stockState() {
        const input = this.panel?.querySelector('.quantity__input');
        if (!input) return null;
        const variant = String(this.panel.querySelector('product-form form [name="id"]')?.value || '');
        const inCart = this.cartSnapshotReady
          ? this.cartQuantities.get(variant) || 0
          : parseInt(input.dataset.cartQuantity || '0', 10) || 0;
        const stock = input.dataset.tnfStock === undefined ? null : parseInt(input.dataset.tnfStock, 10);
        const max = input.dataset.max ? parseInt(input.dataset.max, 10) : null;
        return { input, inCart, stock, remaining: max === null ? null : Math.max(0, max - inCart) };
      }

      setAttr(node, name, value) {
        if (node.getAttribute(name) !== value) node.setAttribute(name, value);
      }

      // The message shown once the customer reaches the highest quantity with + or by typing.
      maxMessage({ inCart, stock, remaining }) {
        if (stock === null) return 'Maximaal bereikt: je kunt er ' + remaining + ' per keer bestellen.';
        const left = remaining === 1 ? 'er is er nog 1 beschikbaar' : 'er zijn er nog ' + remaining + ' beschikbaar';
        if (inCart > 0) return 'Maximaal bereikt: je hebt er al ' + inCart + ' in je winkelwagen, ' + left + '.';
        return remaining === 1 ? 'Maximaal bereikt: er is er nog 1 op voorraad.' : 'Maximaal bereikt: er zijn er nog ' + remaining + ' op voorraad.';
      }

      // touched: the customer used +, − or typed a number. Only then does reaching the maximum show a message.
      applyStockLimit({ touched = false } = {}) {
        const state = this.stockState();
        if (!state) return;
        if (touched) this.qtyTouched = true;
        const { input, inCart, stock, remaining } = state;
        const plus = input.closest('quantity-input')?.querySelector('[name="plus"]');
        let message = '';
        let limit = false;
        if (remaining !== null) {
          if (remaining > 0) {
            this.setAttr(input, 'max', String(remaining));
            if ((parseInt(input.value, 10) || 0) > remaining) input.value = remaining;
            const atMax = (parseInt(input.value, 10) || 0) >= remaining;
            plus?.classList.toggle('disabled', atMax);
            if (atMax && this.qtyTouched) {
              message = this.maxMessage(state);
              limit = true;
            }
          } else {
            this.setAttr(input, 'max', '1');
            plus?.classList.add('disabled');
          }
        }
        const note = this.panel.querySelector('[data-tnf-qty-note]');
        const meta = this.panel.querySelector('[data-tnf-low-stock]');
        if (!note) return;
        if (!message && stock !== null && stock > 0 && remaining === 0) {
          message = 'Je hebt alle ' + stock + ' op voorraad al in je winkelwagen.';
          limit = true;
        }
        note.classList.toggle('tnf-qty-note--limit', limit);
        if (!message) {
          const parts = [];
          if (meta?.dataset.tnfLowStock) parts.push('Nog ' + meta.dataset.tnfLowStock + ' op voorraad');
          if (meta?.dataset.tnfCartNote === 'true' && inCart > 0) parts.push(inCart + ' in je winkelwagen');
          message = parts.join(' · ');
        }
        if (note.textContent.trim() !== message) note.textContent = message;
      }

      // Runs before the theme and MonsterCart add anything: never more than the stock.
      checkStockBeforeAdd() {
        const state = this.stockState();
        if (!state || state.remaining === null) return true;
        if (state.remaining <= 0) {
          this.applyStockLimit();
          return false;
        }
        const value = parseInt(state.input.value, 10) || 1;
        if (value > state.remaining) {
          this.applyStockLimit({ touched: true });
        }
        return true;
      }

      /* ---------- Loading another colour ---------- */

      schedulePrefetch(link) {
        clearTimeout(this.prefetchTimer);
        const id = link.dataset.tnfProduct;
        if (this.loadingSelection || id === this.selectedProductId) return;
        // Briefly passing over a colour does not download its product section.
        this.prefetchTimer = setTimeout(() => {
          if (!this.isConnected || this.loadingSelection) return;
          if (this.cachedPanel(id)) return;
          if (this.prefetchRequest?.id === id) return;
          this.prefetchRequest?.controller.abort();
          const controller = new AbortController();
          const timeout = setTimeout(() => controller.abort(), TNF_REQUEST_TIMEOUT);
          const pending = { id, controller };
          this.prefetchRequest = pending;
          pending.promise = this.loadPanel(link, controller.signal)
            .then((html) => {
              if (!controller.signal.aborted) this.cachePanel(id, html);
              return html;
            })
            .catch(() => null)
            .finally(() => {
              clearTimeout(timeout);
              if (this.prefetchRequest === pending) this.prefetchRequest = null;
            });
        }, 250);
      }

      async loadPanel(link, signal) {
        const id = link.dataset.tnfProduct;
        const url = new URL(link.href, window.location.origin);
        url.searchParams.set('section_id', this.dataset.sectionId);
        const previewTheme = new URL(window.location.href).searchParams.get('preview_theme_id');
        if (previewTheme) url.searchParams.set('preview_theme_id', previewTheme);
        const response = await fetch(url.toString(), { credentials: 'same-origin', signal });
        if (!response.ok) throw new Error('Product section unavailable');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
        const candidate = Array.from(doc.querySelectorAll('[data-tnf-panel]')).find(
          (node) => node.dataset.tnfPanel === id && !node.closest('template')
        );
        if (!candidate) throw new Error('Unexpected product in section response');
        // The page keeps its own picker; the copy in the response is not needed.
        candidate.querySelectorAll('[data-tnf-color-picker]').forEach((node) => node.remove());
        return candidate.outerHTML;
      }

      async preparePanelImage(panel) {
        const source = panel.querySelector('tnf-media-dots .product__media-list .product__media-item img');
        if (!source) return;
        // Usually already downloaded by the hover preview. Decoding before the swap prevents an empty frame.
        const image = new Image();
        let failed = false;
        const loaded = new Promise((resolve) => {
          image.onload = () => resolve(true);
          image.onerror = () => {
            failed = true;
            resolve(false);
          };
        });
        for (const attr of source.attributes) {
          if (!['src', 'srcset', 'loading'].includes(attr.name)) image.setAttribute(attr.name, attr.value);
        }
        image.loading = 'eager';
        if (source.hasAttribute('srcset')) image.setAttribute('srcset', source.getAttribute('srcset'));
        image.setAttribute('src', source.getAttribute('src'));
        let timer;
        // A slow or missing photo never blocks the colour change: wait briefly, then switch anyway.
        const ok = await Promise.race([loaded, new Promise((resolve) => (timer = setTimeout(() => resolve(false), TNF_IMAGE_WAIT)))]);
        clearTimeout(timer);
        if (failed) return;
        if (ok && image.decode) await image.decode().catch(() => {});
        source.replaceWith(image);
      }

      matchTitleTag(nextPanel) {
        // Fetched markup is rendered as a product page (h1). Keep the heading level this page uses.
        const current = this.panel.querySelector('.product__title');
        const next = nextPanel.querySelector('.product__title');
        if (!current || !next || current.tagName === next.tagName) return;
        const title = document.createElement(current.tagName.toLowerCase());
        for (const attr of next.attributes) title.setAttribute(attr.name, attr.value);
        title.innerHTML = next.innerHTML;
        next.replaceWith(title);
      }

      async selectProduct(link) {
        const id = link.dataset.tnfProduct;
        const request = ++this.selectionRequest;
        this.selectionAbort?.abort();
        this.setSelectionBusy(false);
        this.pendingSelectionLink = null;
        clearTimeout(this.prefetchTimer);
        const status = this.picker.querySelector('[data-tnf-load-status]');
        status.classList.add('visually-hidden');
        status.textContent = '';
        if (id === this.panel.dataset.tnfPanel) {
          this.restoreSelection();
          return;
        }
        this.pendingSelectionLink = link;
        this.setSelectionBusy(true);
        this.preview(link);
        status.textContent = link.dataset.tnfTitle + ' laden…';
        const controller = new AbortController();
        this.selectionAbort = controller;
        const timeout = setTimeout(() => controller.abort(), TNF_REQUEST_TIMEOUT);
        const cartVersion = this.cartVersion || 0;
        try {
          let html = this.cachedPanel(id);
          if (!html && this.prefetchRequest?.id === id) html = await this.prefetchRequest.promise;
          if (!html) html = await this.loadPanel(link, controller.signal);
          if (request !== this.selectionRequest || !this.isConnected) return;
          const template = document.createElement('template');
          template.innerHTML = html;
          const nextPanel = template.content.querySelector('[data-tnf-panel]');
          const slot = nextPanel?.querySelector('[data-tnf-picker-slot]');
          const form = nextPanel?.querySelector('product-form form');
          if (!slot || nextPanel.dataset.tnfPanel !== id || (form && !form.querySelector('[name="id"]')?.value)) {
            throw new Error('Incomplete product section');
          }
          await this.preparePanelImage(nextPanel);
          if (request !== this.selectionRequest || !this.isConnected) return;
          // Only cache markup that was fetched after the last cart change.
          if (cartVersion === (this.cartVersion || 0)) this.cachePanel(id, html);
          this.matchTitleTag(nextPanel);
          this.pendingSelectionLink = null;
          this.setSelectionBusy(false);
          this.restoreSelection();
          this.clearCartFeedback();
          nextPanel.setAttribute('data-tnf-instant-preview', '');
          nextPanel.querySelectorAll('.scroll-trigger--offscreen').forEach((node) => node.classList.remove('scroll-trigger--offscreen'));
          // Keep the same picker node, so its event handlers and keyboard focus survive.
          const focus = document.activeElement;
          const restoreLinkFocus = this.picker.contains(focus);
          const oldPanel = this.panel;
          this.panel = nextPanel;
          this.selectedProductId = id;
          slot.replaceChildren(this.picker);
          // The theme moves each product's lightbox to <body>. Remove the previous colour's lightbox,
          // otherwise a click on the photo opens the old colour.
          document.querySelectorAll('[id="ProductModal-' + this.dataset.sectionId + '"]').forEach((modal) => {
            if (modal.hasAttribute('open')) modal.hide?.();
            modal.remove();
          });
          oldPanel.replaceWith(nextPanel);
          this.setupStockLimit();
          this.updateSelectedSwatch();
          this.setColorLabel(link);
          this.picker.querySelector('[data-tnf-announcement]').textContent = link.dataset.tnfTitle + ' geselecteerd';
          status.textContent = '';
          if (restoreLinkFocus && focus?.isConnected) focus.focus({ preventScroll: true });
          // Focus events can preview; immediately reset to the committed product.
          this.restoreSelection();
          if (window.Shopify?.PaymentButton?.init) window.Shopify.PaymentButton.init();
          if (window.ProductModel?.loadShopifyXR) window.ProductModel.loadShopifyXR();
        } catch (error) {
          if (request !== this.selectionRequest || !this.isConnected) return;
          this.pendingSelectionLink = null;
          this.setSelectionBusy(false);
          this.restoreSelection();
          status.classList.remove('visually-hidden');
          status.textContent = 'Deze kleur kon niet worden geladen. De vorige kleur blijft geselecteerd. Klik opnieuw om te proberen.';
        } finally {
          clearTimeout(timeout);
          if (request === this.selectionRequest) {
            this.pendingSelectionLink = null;
            this.setSelectionBusy(false);
          }
        }
      }
    });
  }

  // "Vaak samen gekocht": tick products, set quantities, add them all at once.
  if (!customElements.get('tnf-bundle')) {
    customElements.define('tnf-bundle', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.list = this.querySelector('[data-tnf-bundle-list]');
        this.message = this.querySelector('[data-tnf-bundle-message]');
        this.addEventListener('change', (event) => {
          if (event.target.matches('.tnf-bundle__amount')) this.clamp(event.target);
          this.update();
        });
        this.addEventListener('input', (event) => {
          if (event.target.matches('.tnf-bundle__amount')) this.update();
        });
        this.addEventListener('click', (event) => {
          const step = event.target.closest('.tnf-bundle__step');
          if (step) {
            const input = step.parentElement.querySelector('.tnf-bundle__amount');
            input.value = (parseInt(input.value, 10) || 1) + Number(step.dataset.step);
            this.clamp(input);
            this.update();
          }
          const add = event.target.closest('[data-tnf-bundle-add]');
          if (add) this.add(add.closest('.tnf-bundle__item'));
        });
        this.update();
        this.whenNear(() => this.fill());
      }

      // Runs once the block comes near the screen and the browser has a quiet moment,
      // so filling never competes with loading the photos and the buy button.
      whenNear(run) {
        const go = () => (window.requestIdleCallback ? requestIdleCallback(run, { timeout: 1500 }) : setTimeout(run, 100));
        const target = this.closest('.tnf-block') || this.parentElement;
        if (!window.IntersectionObserver || !target) return go();
        const observer = new IntersectionObserver((entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;
          observer.disconnect();
          go();
        }, { rootMargin: '800px 0px' });
        observer.observe(target);
      }

      items() {
        return Array.from(this.querySelectorAll('.tnf-bundle__item'));
      }

      clamp(input) {
        const max = parseInt(input.max, 10) || 99;
        const value = Math.min(max, Math.max(1, parseInt(input.value, 10) || 1));
        input.value = value;
        const row = input.closest('.tnf-bundle__item');
        row.querySelector('[data-step="-1"]').disabled = value <= 1;
        row.querySelector('[data-step="1"]').disabled = value >= max;
      }

      money(cents) {
        const format = this.dataset.moneyFormat || '€{' + '{amount_with_comma_separator}' + '}';
        const value = cents / 100;
        const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const withDecimals = (dec, sep) => { const p = value.toFixed(2).split('.'); return group(p[0], sep) + dec + p[1]; };
        const map = {
          amount: withDecimals('.', ','),
          amount_no_decimals: group(String(Math.round(value)), ','),
          amount_with_comma_separator: withDecimals(',', '.'),
          amount_no_decimals_with_comma_separator: group(String(Math.round(value)), '.'),
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] || map.amount_with_comma_separator);
      }

      update() {
        this.items().forEach((row) => this.clamp(row.querySelector('.tnf-bundle__amount')));
      }

      // Fills empty places: first Shopify's automatic recommendations, then random products from the
      // shop (or the chosen collection). Random picks never come from an excluded category, from the
      // categories this product is in, or from the category the customer came from.
      async fill() {
        let need = parseInt(this.dataset.need, 10) || 0;
        if (need > 0) {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const split = (value) => (value || '').split('|').filter(Boolean);
          const skip = new Set(split(this.dataset.exclude));
          this.items().forEach((row) => skip.add(row.dataset.product));
          const excluded = await this.idsOf(root, split(this.dataset.excludeCollections));
          excluded.forEach((id) => skip.add(id));
          const add = (product) => {
            const variant = (product.variants || []).find((v) => v.available);
            if (need <= 0 || !product.available || !variant || skip.has(String(product.id))) return;
            skip.add(String(product.id));
            this.list.append(this.row(product, variant));
            need--;
          };
          if (this.dataset.reco !== 'false') {
            try {
              const response = await fetch(`${root}recommendations/products.json?product_id=${this.dataset.productId}&limit=10&intent=related`);
              if (response.ok) ((await response.json()).products || []).forEach(add);
            } catch (error) {}
          }
          const shuffle = (list) => {
            for (let i = list.length - 1; i > 0; i--) {
              const j = Math.floor(Math.random() * (i + 1));
              [list[i], list[j]] = [list[j], list[i]];
            }
            return list;
          };
          const own = need > 0 ? await this.idsOf(root, split(this.dataset.ownCollections)) : new Set();
          // Ranked categories: walk the list in order. Already a product from this category in the
          // bundle? Then on to the next one. If not, one product from it is added.
          for (const handle of split(this.dataset.rank)) {
            if (need <= 0) break;
            const list = await this.products(root, handle);
            const inCategory = new Set(list.map((p) => String(p.id)));
            if (this.items().some((row) => inCategory.has(row.dataset.product))) continue;
            const options = list.filter((p) => p.available && !skip.has(String(p.id)) && !own.has(String(p.id)));
            if (!options.length) continue;
            add(this.dataset.rankPick === 'first' ? options[0] : shuffle(options)[0]);
          }
          if (need > 0 && this.dataset.random !== 'false') {
            const pool = (await this.products(root, this.dataset.pool || 'all')).filter((p) => p.available && !skip.has(String(p.id)));
            // Other categories first; only if those run out, products from this category.
            shuffle(pool.filter((p) => !own.has(String(p.id)))).forEach(add);
            shuffle(pool.filter((p) => own.has(String(p.id)))).forEach(add);
          }
        }
        const extras = this.items().filter((row) => !row.hasAttribute('data-current'));
        const wrapper = this.closest('.tnf-block');
        if (!extras.length) {
          this.hidden = true;
          if (wrapper) wrapper.hidden = true;
          return;
        }
        this.hidden = false;
        if (wrapper) wrapper.hidden = false;
        this.update();
      }

      // All product ids of a few collections.
      async idsOf(root, handles) {
        const ids = new Set();
        const lists = await Promise.all(handles.map((handle) => this.products(root, handle)));
        lists.forEach((list) => list.forEach((p) => ids.add(String(p.id))));
        return ids;
      }

      // Products of one collection (/collections/<handle>/products.json, 250 per page), kept for
      // 10 minutes in this browser (all tabs) so the next product page doesn't fetch them again.
      async products(root, handle) {
        const key = 'tnf-bundle:' + root + handle;
        try {
          const saved = JSON.parse(localStorage.getItem(key) || 'null');
          if (saved && Date.now() - saved.time < 600000) return saved.items;
        } catch (error) {}
        const items = [];
        for (let page = 1; page <= 8; page++) {
          let products = [];
          try {
            const response = await fetch(`${root}collections/${encodeURIComponent(handle)}/products.json?limit=250&page=${page}`);
            if (!response.ok) break;
            products = (await response.json()).products || [];
          } catch (error) {
            break;
          }
          products.forEach((p) => {
            const variant = (p.variants || []).find((v) => v.available);
            const image = (variant && variant.featured_image && variant.featured_image.src) || (p.images && p.images[0] && p.images[0].src) || '';
            items.push({
              id: p.id,
              title: p.title,
              url: `${root}products/${p.handle}`,
              available: !!variant,
              featured_image: image,
              variants: variant ? [{ id: variant.id, available: true, price: Math.round(parseFloat(variant.price) * 100) }] : []
            });
          });
          if (products.length < 250) break;
        }
        try {
          localStorage.setItem(key, JSON.stringify({ time: Date.now(), items }));
        } catch (error) {}
        return items;
      }

      row(product, variant) {
        const row = document.createElement('div');
        row.className = 'tnf-bundle__item';
        row.dataset.product = product.id;
        row.dataset.variant = variant.id;
        row.dataset.price = variant.price;
        const image = (variant.featured_image && variant.featured_image.src) || product.featured_image;
        const src = image ? image + (image.includes('?') ? '&' : '?') + 'width=160' : '';
        row.innerHTML = `
          <a class="tnf-bundle__img" tabindex="-1" aria-hidden="true">${src ? '<img loading="lazy" alt="">' : ''}</a>
          <div class="tnf-bundle__info"><a class="tnf-bundle__name"></a><span class="tnf-bundle__price"></span></div>
          <div class="tnf-bundle__qty">
            <button type="button" class="tnf-bundle__step" data-step="-1">−</button>
            <input type="number" class="tnf-bundle__amount" value="1" min="1" max="99" inputmode="numeric">
            <button type="button" class="tnf-bundle__step" data-step="1">+</button>
          </div>
          <button type="button" class="button button--secondary tnf-bundle__add" data-tnf-bundle-add></button>`;
        const label = this.dataset.addLabel || 'Voeg toe';
        const add = row.querySelector('[data-tnf-bundle-add]');
        add.textContent = label;
        add.setAttribute('aria-label', label + ': ' + product.title);
        row.querySelectorAll('a').forEach((a) => (a.href = product.url));
        if (src) row.querySelector('img').src = src;
        row.querySelector('.tnf-bundle__name').textContent = product.title;
        row.querySelector('.tnf-bundle__price').textContent = this.money(variant.price);
        row.querySelector('[data-step="-1"]').setAttribute('aria-label', 'Minder ' + product.title);
        row.querySelector('[data-step="1"]').setAttribute('aria-label', 'Meer ' + product.title);
        row.querySelector('.tnf-bundle__amount').setAttribute('aria-label', 'Aantal ' + product.title);
        return row;
      }

      // Adds one row (with its quantity) to the cart.
      async add(row) {
        const button = row && row.querySelector('[data-tnf-bundle-add]');
        if (!button || row.busy) return;
        const quantity = parseInt(row.querySelector('.tnf-bundle__amount').value, 10) || 1;
        const label = this.dataset.addLabel || 'Voeg toe';
        row.busy = true;
        button.setAttribute('aria-busy', 'true');
        button.disabled = true;
        this.message.textContent = '';
        try {
          const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(row.dataset.variant), quantity }] }),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            this.message.textContent = data.description || data.message || 'Toevoegen lukte niet. Probeer het opnieuw.';
            return;
          }
          button.textContent = 'Toegevoegd ✓';
          button.classList.add('is-added');
          // MonsterCart: refresh and open the cart drawer. Otherwise tell the theme the cart changed.
          if (typeof window.monster_refresh === 'function') {
            window.monster_refresh(true);
          } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tnf-bundle', cartData: data });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          this.closest('tnf-featured-colors')?.refreshCartSnapshot?.();
          clearTimeout(row.addedTimer);
          row.addedTimer = setTimeout(() => {
            button.textContent = label;
            button.classList.remove('is-added');
          }, 2000);
        } catch (error) {
          this.message.textContent = 'Toevoegen lukte niet. Controleer je verbinding en probeer het opnieuw.';
        } finally {
          row.busy = false;
          button.removeAttribute('aria-busy');
          button.disabled = false;
        }
      }
    });
  }

  // Icon tiles: tap (or Enter/Space) opens the extra text; tapping elsewhere or Escape closes it.
  if (!customElements.get('tnf-usps')) {
    customElements.define('tnf-usps', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.addEventListener('click', (event) => {
          const tile = event.target.closest('.tnf-usp__tile');
          if (!tile) return;
          const item = tile.closest('.tnf-usp');
          this.toggle(item, !item.classList.contains('is-open'));
        });
        this.onOutside = (event) => {
          if (!this.contains(event.target)) this.closeAll();
        };
        this.onKey = (event) => {
          if (event.key === 'Escape') this.closeAll();
        };
        // Scrolling closes an open text bubble (desktop and mobile); hover bubbles stay hidden until scrolling stops.
        this.onScroll = () => {
          this.closeAll();
          this.classList.add('is-scrolling');
          clearTimeout(this.scrollTimer);
          this.scrollTimer = setTimeout(() => this.classList.remove('is-scrolling'), 250);
        };
        document.addEventListener('click', this.onOutside);
        document.addEventListener('keydown', this.onKey);
        window.addEventListener('scroll', this.onScroll, { passive: true });
      }
      disconnectedCallback() {
        document.removeEventListener('click', this.onOutside);
        document.removeEventListener('keydown', this.onKey);
        window.removeEventListener('scroll', this.onScroll);
        clearTimeout(this.scrollTimer);
        this.started = false;
      }
      toggle(item, open) {
        this.closeAll(item);
        item.classList.toggle('is-open', open);
        item.querySelector('.tnf-usp__tile').setAttribute('aria-expanded', String(open));
      }
      closeAll(except) {
        this.querySelectorAll('.tnf-usp.is-open').forEach((item) => {
          if (item === except) return;
          item.classList.remove('is-open');
          item.querySelector('.tnf-usp__tile').setAttribute('aria-expanded', 'false');
        });
      }
    });
  }

  // Free-shipping bar (block): updates by itself when the cart changes (theme, MonsterCart or another app).
  // One shared cart reader for every bar on the page; it starts when the first bar appears.
  const tnfCartWatch = () => window.tnfCartWatch || (window.tnfCartWatch = (function () {
    let listeners = [];
    let last = null;
    let timer;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const isCartChange = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart) return;
            last = cart;
            listeners.forEach((fn) => fn(cart));
          })
          .catch(() => {});
      }, 150);
    };
    if (window.fetch && !window.fetch.__tnfCart) {
      const originalFetch = window.fetch;
      const wrapped = function (input) {
        const url = typeof input === 'string' ? input : input && input.url;
        const result = originalFetch.apply(this, arguments);
        if (isCartChange(url)) result.then(refresh, () => {});
        return result;
      };
      wrapped.__tnfCart = true;
      window.fetch = wrapped;
    }
    const originalOpen = XMLHttpRequest.prototype.open;
    if (!originalOpen.__tnfCart) {
      const open = function (method, url) {
        if (isCartChange(url)) this.addEventListener('loadend', refresh);
        return originalOpen.apply(this, arguments);
      };
      open.__tnfCart = true;
      XMLHttpRequest.prototype.open = open;
    }
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => document.addEventListener(name, refresh));
    window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
    // Read once when the browser is idle, in case the page was loaded ahead of time (prefetch) or from a cache.
    (window.requestIdleCallback || ((fn) => setTimeout(fn, 300)))(refresh);
    return {
      subscribe(fn) {
        listeners.push(fn);
        if (last) fn(last);
        return () => { listeners = listeners.filter((f) => f !== fn); };
      },
      refresh,
    };
  })());

  if (!customElements.get('tnf-free-shipping')) {
    customElements.define('tnf-free-shipping', class extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = tnfCartWatch().subscribe((cart) => this.update(cart));
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      money(cents) {
        const format = (this.dataset.moneyFormat || '€{' + '{amount_with_comma_separator}' + '}').replace(/<[^>]*>/g, '');
        const value = cents / 100;
        const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const withDecimals = (dec, sep) => { const p = value.toFixed(2).split('.'); return group(p[0], sep) + dec + p[1]; };
        const map = {
          amount: withDecimals('.', ','),
          amount_no_decimals: group(String(Math.round(value)), ','),
          amount_with_comma_separator: withDecimals(',', '.'),
          amount_no_decimals_with_comma_separator: group(String(Math.round(value)), '.'),
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] || map.amount_with_comma_separator);
      }
      update(cart) {
        const threshold = parseInt(this.dataset.threshold, 10) || 0;
        const total = Number(cart.total_price) || 0;
        const count = Number(cart.item_count) || 0;
        const remaining = Math.max(0, threshold - total);
        const key = count === 0 ? 'empty' : remaining > 0 ? 'below' : 'reached';
        const template = this.dataset['text' + key.charAt(0).toUpperCase() + key.slice(1)] || '';
        const text = this.querySelector('[data-tnf-fs-text]');
        if (text) {
          // "[bedrag]" becomes the remaining amount in bold; the rest stays plain text.
          const nodes = [];
          template.split('[bedrag]').forEach((part, i) => {
            if (i > 0) {
              const strong = document.createElement('strong');
              strong.textContent = this.money(remaining);
              nodes.push(strong);
            }
            if (part) nodes.push(document.createTextNode(part));
          });
          text.replaceChildren(...nodes);
        }
        const fill = this.querySelector('[data-tnf-fs-fill]');
        if (fill) fill.style.width = (threshold ? Math.min(100, (total / threshold) * 100) : 100) + '%';
        this.dataset.state = key;
      }
    });
  }

  // Discount at the price, read from Shopify itself: a throwaway cart (Storefront API, no token needed) with this
  // one product and the customer's discount code(s) returns exactly what the checkout will charge. The visitor's own
  // cart is never touched. Results are kept for 10 minutes in this browser. The request goes through a hidden
  // frame's own fetch, so analytics scripts that listen to fetch don't count it as "added to cart".
  const tnfPriceCache = new Map();
  let tnfCleanFetch = null;
  const tnfFetch = (...args) => {
    if (!tnfCleanFetch) {
      try {
        const frame = document.createElement('iframe');
        frame.hidden = true;
        frame.setAttribute('aria-hidden', 'true');
        frame.tabIndex = -1;
        document.body.appendChild(frame);
        const native = frame.contentWindow && frame.contentWindow.fetch;
        tnfCleanFetch = native ? native.bind(frame.contentWindow) : window.fetch.bind(window);
      } catch (error) {
        tnfCleanFetch = window.fetch.bind(window);
      }
    }
    return tnfCleanFetch(...args);
  };
  const tnfDiscountCodes = (cart) => {
    const codes = new Set();
    (cart && cart.discount_codes || []).forEach((d) => d && d.code && codes.add(d.code));
    const cookie = document.cookie.split('; ').find((c) => c.startsWith('discount_code='));
    if (cookie) decodeURIComponent(cookie.split('=')[1] || '').split(',').forEach((c) => c && codes.add(c.trim()));
    return [...codes].sort();
  };
  const TNF_PRICE_QUERY = 'mutation tnfPrice($input: CartInput!) { cartCreate(input: $input) { cart { lines(first: 1) { nodes { cost { amountPerQuantity { amount } compareAtAmountPerQuantity { amount } totalAmount { amount } } discountAllocations { discountedAmount { amount } ... on CartCodeDiscountAllocation { code } } } } } } }';

  async function tnfDiscountedPrice(variantId, codes, country) {
    const key = [variantId, codes.join(','), country].join('|');
    if (tnfPriceCache.has(key)) return tnfPriceCache.get(key);
    const storeKey = 'tnf-price:' + key;
    try {
      const saved = JSON.parse(localStorage.getItem(storeKey) || 'null');
      if (saved && Date.now() - saved.time < 600000) {
        tnfPriceCache.set(key, saved.value);
        return saved.value;
      }
    } catch (error) {}
    const job = (async () => {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      const response = await tnfFetch(root.replace(/\/[a-z]{2}(-[a-z]{2})?\/$/i, '/') + 'api/2025-07/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          query: TNF_PRICE_QUERY,
          variables: { input: { lines: [{ merchandiseId: 'gid://shopify/ProductVariant/' + variantId, quantity: 1 }], discountCodes: codes, buyerIdentity: { countryCode: country } } },
        }),
      });
      if (!response.ok) throw new Error(String(response.status));
      const line = (await response.json())?.data?.cartCreate?.cart?.lines?.nodes?.[0];
      if (!line) throw new Error('no line');
      const cents = (money) => Math.round(parseFloat((money && money.amount) || '0') * 100);
      const value = {
        price: cents(line.cost.amountPerQuantity),
        compare: cents(line.cost.compareAtAmountPerQuantity),
        total: cents(line.cost.totalAmount),
        code: (line.discountAllocations || []).map((a) => a.code).find(Boolean) || '',
      };
      try { localStorage.setItem(storeKey, JSON.stringify({ time: Date.now(), value })); } catch (error) {}
      return value;
    })();
    tnfPriceCache.set(key, job);
    job.catch(() => tnfPriceCache.delete(key));
    return job;
  }

  if (!customElements.get('tnf-price')) {
    customElements.define('tnf-price', class extends HTMLElement {
      connectedCallback() {
        if (!this.hasAttribute('data-auto')) return;
        // What the server showed (normal price or the set discount), to go back to when a code is removed.
        const main = this.querySelector('[data-tnf-price-main]');
        const note = this.querySelector('[data-tnf-price-note]');
        const exVat = this.querySelector('[data-tnf-ex-vat]');
        this.original = {
          main: main ? main.innerHTML : '',
          note: note ? note.textContent : '',
          noteHidden: note ? note.hidden : true,
          exVat: exVat ? exVat.textContent : '',
        };
        this.run(null);
        // A discount code added later (e.g. in the cart) updates the price too.
        this.unsubscribe = tnfCartWatch().subscribe((cart) => this.run(cart));
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      money(cents) {
        const format = this.dataset.moneyFormat || '€{' + '{amount_with_comma_separator}' + '}';
        const value = cents / 100;
        const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const withDecimals = (dec, sep) => { const p = value.toFixed(2).split('.'); return group(p[0], sep) + dec + p[1]; };
        const map = {
          amount: withDecimals('.', ','),
          amount_no_decimals: group(String(Math.round(value)), ','),
          amount_with_comma_separator: withDecimals(',', '.'),
          amount_no_decimals_with_comma_separator: group(String(Math.round(value)), '.'),
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] || map.amount_with_comma_separator);
      }
      async run(cart) {
        let codes = tnfDiscountCodes(cart);
        if (!cart) {
          try {
            const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
            codes = tnfDiscountCodes(await (await tnfFetch(root + 'cart.js', { credentials: 'same-origin' })).json());
          } catch (error) {}
        }
        const signature = codes.join(',');
        if (this.lastSignature === signature) return;
        this.lastSignature = signature;
        // Only checking discount codes: without a code there is nothing to check; show what the server showed.
        if (this.hasAttribute('data-codes-only') && !codes.length) {
          this.restore();
          return;
        }
        let result;
        try {
          result = await tnfDiscountedPrice(this.dataset.variantId, codes, this.dataset.country || 'NL');
        } catch (error) {
          return; // Leave the normal price as it is.
        }
        if (!this.isConnected || this.lastSignature !== signature) return;
        this.show(result);
      }
      restore() {
        if (!this.original || !this.changed) return;
        const main = this.querySelector('[data-tnf-price-main]');
        const note = this.querySelector('[data-tnf-price-note]');
        const exVat = this.querySelector('[data-tnf-ex-vat]');
        if (main) main.innerHTML = this.original.main;
        if (note) {
          note.textContent = this.original.note;
          note.hidden = this.original.noteHidden;
        }
        if (exVat) exVat.textContent = this.original.exVat;
        this.changed = false;
      }
      show({ price, compare, total, code }) {
        const was = Math.max(compare || 0, price || 0, Number(this.dataset.price) || 0);
        const main = this.querySelector('[data-tnf-price-main]');
        const note = this.querySelector('[data-tnf-price-note]');
        // Same as the server already shows (e.g. the code doesn't apply to this product): change nothing.
        if (this.hasAttribute('data-codes-only') && !code) {
          this.restore();
          return;
        }
        if (!main || !total || total >= was) {
          this.restore();
          return;
        }
        this.changed = true;
        const pct = Math.round(((was - total) / was) * 100);
        const badge = this.dataset.badge === 'none' ? '' : this.dataset.badge === 'text' ? pct + '% korting' : '-' + pct + '%';
        const sale = document.createElement('div');
        sale.className = 'tnf-sale' + (main.querySelector('.tnf-sale') ? '' : ' is-new');
        sale.innerHTML = '<span class="visually-hidden">Aanbiedingsprijs</span><span class="tnf-sale__now price-item price-item--sale"></span><span class="visually-hidden">Normale prijs</span><s class="tnf-sale__was"></s>' + (badge ? '<span class="tnf-sale__badge"></span>' : '');
        sale.querySelector('.tnf-sale__now').textContent = this.money(total);
        sale.querySelector('.tnf-sale__was').textContent = this.money(was);
        if (badge) sale.querySelector('.tnf-sale__badge').textContent = badge;
        main.replaceChildren(sale);
        const exVat = this.querySelector('[data-tnf-ex-vat]');
        const divisor = Number(this.dataset.vatDivisor) || 0;
        if (exVat) exVat.textContent = this.money(divisor ? Math.round((total * 100) / divisor) : total) + ' ' + (this.dataset.exVatLabel || '');
        if (note) {
          const text = code && this.dataset.codeNote ? this.dataset.codeNote.replace('[code]', code) : (this.dataset.note || '').replace('[procent]', pct);
          note.textContent = text;
          note.hidden = !text;
        }
      }
    });
  }

  // Description bars: empty lines from the editor (an extra Enter, a lone space) never leave a gap.
  if (!customElements.get('tnf-desc')) {
    customElements.define('tnf-desc', class extends HTMLElement {
      connectedCallback() {
        this.querySelectorAll('.tnf-desc__content').forEach((content) => {
          content.querySelectorAll('p, div').forEach((node) => {
            const text = node.textContent.replace(/[\s ​]/g, '');
            if (!text && !node.querySelector('img, video, iframe, svg, input')) node.remove();
          });
        });
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnt-gratis-verzending"] && !Shopify.designMode) return;
  try {
    
(() => {
  // Free-shipping bar: updates by itself when the cart changes (theme, MonsterCart or another app).
  // One shared cart reader for every bar on the page; it starts when the first bar appears.
  const tnfCartWatch = () => window.tnfCartWatch || (window.tnfCartWatch = (function () {
    let listeners = [];
    let last = null;
    let timer;
    const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    const isCartChange = (url) => /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
    const refresh = () => {
      clearTimeout(timer);
      timer = setTimeout(() => {
        fetch(root + 'cart.js', { credentials: 'same-origin', cache: 'no-store' })
          .then((r) => (r.ok ? r.json() : null))
          .then((cart) => {
            if (!cart) return;
            last = cart;
            listeners.forEach((fn) => fn(cart));
          })
          .catch(() => {});
      }, 150);
    };
    if (window.fetch && !window.fetch.__tnfCart) {
      const originalFetch = window.fetch;
      const wrapped = function (input) {
        const url = typeof input === 'string' ? input : input && input.url;
        const result = originalFetch.apply(this, arguments);
        if (isCartChange(url)) result.then(refresh, () => {});
        return result;
      };
      wrapped.__tnfCart = true;
      window.fetch = wrapped;
    }
    const originalOpen = XMLHttpRequest.prototype.open;
    if (!originalOpen.__tnfCart) {
      const open = function (method, url) {
        if (isCartChange(url)) this.addEventListener('loadend', refresh);
        return originalOpen.apply(this, arguments);
      };
      open.__tnfCart = true;
      XMLHttpRequest.prototype.open = open;
    }
    ['cart:updated', 'cart:refresh', 'cart:change'].forEach((name) => document.addEventListener(name, refresh));
    window.addEventListener('pageshow', (event) => { if (event.persisted) refresh(); });
    // Read once when the browser is idle, in case the page was loaded ahead of time (prefetch) or from a cache.
    (window.requestIdleCallback || ((fn) => setTimeout(fn, 300)))(refresh);
    return {
      subscribe(fn) {
        listeners.push(fn);
        if (last) fn(last);
        return () => { listeners = listeners.filter((f) => f !== fn); };
      },
      refresh,
    };
  })());

  if (!customElements.get('tnf-free-shipping')) {
    customElements.define('tnf-free-shipping', class extends HTMLElement {
      connectedCallback() {
        this.unsubscribe = tnfCartWatch().subscribe((cart) => this.update(cart));
      }
      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }
      money(cents) {
        const format = (this.dataset.moneyFormat || '€{' + '{amount_with_comma_separator}' + '}').replace(/<[^>]*>/g, '');
        const value = cents / 100;
        const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const withDecimals = (dec, sep) => { const p = value.toFixed(2).split('.'); return group(p[0], sep) + dec + p[1]; };
        const map = {
          amount: withDecimals('.', ','),
          amount_no_decimals: group(String(Math.round(value)), ','),
          amount_with_comma_separator: withDecimals(',', '.'),
          amount_no_decimals_with_comma_separator: group(String(Math.round(value)), '.'),
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] || map.amount_with_comma_separator);
      }
      update(cart) {
        const threshold = parseInt(this.dataset.threshold, 10) || 0;
        const total = Number(cart.total_price) || 0;
        const count = Number(cart.item_count) || 0;
        const remaining = Math.max(0, threshold - total);
        const key = count === 0 ? 'empty' : remaining > 0 ? 'below' : 'reached';
        const template = this.dataset['text' + key.charAt(0).toUpperCase() + key.slice(1)] || '';
        const text = this.querySelector('[data-tnf-fs-text]');
        if (text) {
          // "[bedrag]" becomes the remaining amount in bold; the rest stays plain text.
          const nodes = [];
          template.split('[bedrag]').forEach((part, i) => {
            if (i > 0) {
              const strong = document.createElement('strong');
              strong.textContent = this.money(remaining);
              nodes.push(strong);
            }
            if (part) nodes.push(document.createTextNode(part));
          });
          text.replaceChildren(...nodes);
        }
        const fill = this.querySelector('[data-tnf-fs-fill]');
        if (fill) fill.style.width = (threshold ? Math.min(100, (total / threshold) * 100) : 100) + '%';
        this.dataset.state = key;
      }
    });
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tnt-productgrid"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tnf-product-grid')) {
    customElements.define('tnf-product-grid', class extends HTMLElement {
      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.addEventListener('click', (event) => {
          const add = event.target.closest('[data-tnf-pg-add]');
          if (add) {
            event.preventDefault();
            this.add(add);
            return;
          }
          const more = event.target.closest('[data-tnf-pg-more]');
          if (more) {
            event.preventDefault();
            this.loadMore(more);
          }
        });
        // Discount codes: one check with Shopify for all cards, only for a customer who has a code.
        this.checkCodes(null);
        if (window.tnfCartWatch) {
          this.unsubscribe = window.tnfCartWatch.subscribe((cart) => this.checkCodes(cart));
        } else {
          this.onCart = () => this.checkCodes(null, true);
          ['cart:updated', 'cart:refresh'].forEach((name) => document.addEventListener(name, this.onCart));
        }
        // Sorting: reload the collection with the chosen order (keeps other filters in the address).
        const sort = this.querySelector('[data-tnf-sort] select');
        if (sort) {
          sort.addEventListener('change', () => {
            const url = new URL(window.location.href);
            url.searchParams.set('sort_by', sort.value);
            url.searchParams.delete('page');
            window.location.href = url.toString();
          });
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.onCart) ['cart:updated', 'cart:refresh'].forEach((name) => document.removeEventListener(name, this.onCart));
      }

      // fetch from a hidden frame, so analytics scripts that listen to the page's fetch don't count the
      // throwaway price check as "added to cart".
      cleanFetch(...args) {
        if (!window.tnfCleanFetch) {
          try {
            const frame = document.createElement('iframe');
            frame.hidden = true;
            frame.setAttribute('aria-hidden', 'true');
            frame.tabIndex = -1;
            document.body.appendChild(frame);
            window.tnfCleanFetch = frame.contentWindow.fetch.bind(frame.contentWindow);
          } catch (error) {
            window.tnfCleanFetch = window.fetch.bind(window);
          }
        }
        return window.tnfCleanFetch(...args);
      }

      money(cents) {
        const format = this.dataset.moneyFormat || '€{' + '{amount_with_comma_separator}' + '}';
        const value = cents / 100;
        const group = (n, sep) => n.replace(/\B(?=(\d{3})+(?!\d))/g, sep);
        const withDecimals = (dec, sep) => { const p = value.toFixed(2).split('.'); return group(p[0], sep) + dec + p[1]; };
        const map = {
          amount: withDecimals('.', ','),
          amount_no_decimals: group(String(Math.round(value)), ','),
          amount_with_comma_separator: withDecimals(',', '.'),
          amount_no_decimals_with_comma_separator: group(String(Math.round(value)), '.'),
        };
        return format.replace(/\{\{\s*(\w+)\s*\}\}/, (m, key) => map[key] || map.amount_with_comma_separator);
      }

      // The customer's discount code(s): from the cart, or from a discount link (cookie).
      async codes(cart) {
        if (!cart) {
          try {
            cart = await (await this.cleanFetch(this.root + 'cart.js', { credentials: 'same-origin' })).json();
          } catch (error) {
            cart = null;
          }
        }
        const codes = new Set();
        ((cart && cart.discount_codes) || []).forEach((d) => d && d.code && codes.add(d.code));
        const cookie = document.cookie.split('; ').find((c) => c.startsWith('discount_code='));
        if (cookie) decodeURIComponent(cookie.split('=')[1] || '').split(',').forEach((c) => c && codes.add(c.trim()));
        return [...codes].sort();
      }

      async checkCodes(cart, force = false) {
        const codes = await this.codes(cart);
        const signature = codes.join(',');
        const cards = [...this.querySelectorAll('.tnf-pcard[data-code-check]')];
        if (!codes.length) {
          cards.forEach((card) => this.restoreCard(card));
          this.codeSignature = '';
          return;
        }
        const todo = cards.filter((card) => force || card.dataset.codeSignature !== signature);
        if (!todo.length) return;
        todo.forEach((card) => (card.dataset.codeSignature = signature));
        const ids = [...new Set(todo.map((card) => card.dataset.variantId))];
        let results = {};
        try {
          const query = 'mutation tnfGrid($input: CartInput!) { cartCreate(input: $input) { cart { lines(first: 100) { nodes { merchandise { ... on ProductVariant { id } } cost { amountPerQuantity { amount } compareAtAmountPerQuantity { amount } totalAmount { amount } } discountAllocations { ... on CartCodeDiscountAllocation { code } } } } } } }';
          const response = await this.cleanFetch(this.root.replace(/\/[a-z]{2}(-[a-z]{2})?\/$/i, '/') + 'api/2025-07/graphql.json', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({
              query,
              variables: { input: { lines: ids.slice(0, 100).map((id) => ({ merchandiseId: 'gid://shopify/ProductVariant/' + id, quantity: 1 })), discountCodes: codes, buyerIdentity: { countryCode: this.dataset.country || 'NL' } } },
            }),
          });
          if (!response.ok) return;
          const nodes = (await response.json())?.data?.cartCreate?.cart?.lines?.nodes || [];
          const cents = (money) => Math.round(parseFloat((money && money.amount) || '0') * 100);
          nodes.forEach((line) => {
            const id = String(line.merchandise?.id || '').split('/').pop();
            results[id] = {
              price: cents(line.cost.amountPerQuantity),
              compare: cents(line.cost.compareAtAmountPerQuantity),
              total: cents(line.cost.totalAmount),
              code: (line.discountAllocations || []).map((a) => a.code).find(Boolean) || '',
            };
          });
        } catch (error) {
          return;
        }
        todo.forEach((card) => {
          if (card.dataset.codeSignature !== signature) return;
          const r = results[card.dataset.variantId];
          if (r && r.code && r.total < Math.max(r.price, r.compare)) this.showCard(card, r);
          else this.restoreCard(card);
        });
      }

      showCard(card, { price, compare, total }) {
        const priceNode = card.querySelector('[data-tnf-price]');
        const badges = card.querySelector('.tnf-pcard__badges');
        if (!priceNode) return;
        if (!card.tnfOriginal) card.tnfOriginal = { price: priceNode.innerHTML, badges: badges ? badges.innerHTML : '' };
        const was = Math.max(compare || 0, price || 0, Number(card.dataset.price) || 0);
        const pct = Math.round(((was - total) / was) * 100);
        priceNode.innerHTML = '<span class="tnf-pcard__now tnf-pcard__now--sale"></span><s class="tnf-pcard__was"><span class="visually-hidden">Normale prijs </span></s>';
        priceNode.querySelector('.tnf-pcard__now').textContent = this.money(total);
        priceNode.querySelector('.tnf-pcard__was').append(this.money(was));
        if (badges && this.dataset.showSale !== 'false') {
          let badge = badges.querySelector('.tnf-pcard__badge--sale');
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'tnf-pcard__badge tnf-pcard__badge--sale';
            const sold = badges.querySelector('.tnf-pcard__badge--sold');
            badges.insertBefore(badge, sold);
          }
          badge.textContent = '-' + pct + '%';
        }
      }

      restoreCard(card) {
        if (!card.tnfOriginal) return;
        const priceNode = card.querySelector('[data-tnf-price]');
        const badges = card.querySelector('.tnf-pcard__badges');
        if (priceNode) priceNode.innerHTML = card.tnfOriginal.price;
        if (badges) badges.innerHTML = card.tnfOriginal.badges;
        card.tnfOriginal = null;
      }

      get root() {
        return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      }

      // "Voeg toe": adds one piece and opens MonsterCart (or tells the theme the cart changed).
      async add(button) {
        if (button.getAttribute('aria-busy') === 'true') return;
        const label = button.dataset.label || 'Voeg toe';
        const message = this.querySelector('[data-tnf-pg-message]');
        button.setAttribute('aria-busy', 'true');
        if (message) message.textContent = '';
        try {
          const response = await fetch(this.root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] }),
          });
          const data = await response.json().catch(() => ({}));
          if (!response.ok) {
            if (message) message.textContent = data.description || data.message || 'Toevoegen lukte niet. Probeer het opnieuw.';
            return;
          }
          button.textContent = 'Toegevoegd ✓';
          if (typeof window.monster_refresh === 'function') {
            window.monster_refresh(true);
          } else if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'tnf-product-grid', cartData: data });
          }
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          clearTimeout(button.addedTimer);
          button.addedTimer = setTimeout(() => (button.textContent = label), 2000);
        } catch (error) {
          if (message) message.textContent = 'Toevoegen lukte niet. Controleer je verbinding en probeer het opnieuw.';
        } finally {
          button.removeAttribute('aria-busy');
        }
      }

      // "Meer laden": fetches the next page of this section and adds its products below.
      async loadMore(link) {
        if (link.getAttribute('aria-busy') === 'true') return;
        const list = this.querySelector('[data-tnf-pg-list]');
        link.setAttribute('aria-busy', 'true');
        try {
          const url = new URL(link.href, window.location.href);
          url.searchParams.set('section_id', this.dataset.sectionId);
          const response = await fetch(url.toString());
          if (!response.ok) throw new Error(String(response.status));
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          const added = [...doc.querySelectorAll('[data-tnf-pg-list] > li')].map((item) => {
            item.classList.remove('scroll-trigger', 'animate--slide-in');
            return list.appendChild(document.importNode(item, true));
          });
          const hadFocus = document.activeElement === link;
          const progress = doc.querySelector('[data-tnf-pg-progress]');
          const own = this.querySelector('[data-tnf-pg-progress]');
          if (progress && own) own.textContent = progress.textContent;
          const next = doc.querySelector('[data-tnf-pg-more]');
          if (next) {
            link.href = next.getAttribute('href');
          } else {
            link.remove();
          }
          // Keyboard and screen reader users continue at the first new product.
          if (hadFocus && added[0]) added[0].querySelector('.tnf-pcard__link')?.focus({ preventScroll: true });
          this.checkCodes(null);
        } catch (error) {
          window.location.href = link.href;
        } finally {
          link.removeAttribute('aria-busy');
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
